import { AtendimentoType } from '_metronic/helpers'
import { createListFilters, IOption } from 'app/components'

export type TiposAtendimentoVinculosFilters = {
  tipoAtendimento?: IOption<AtendimentoType>
  empresa?: IOption<number>
  /** Depende da instituição (é limpa quando a instituição sai). */
  unidade?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } =
  createListFilters<TiposAtendimentoVinculosFilters>({
    tipoAtendimento: undefined,
    empresa: undefined,
    unidade: undefined,
  })
